import React from 'react';

import type { RouteObject } from 'react-router-dom';

import { ActFormView } from '@/pages/MeteringPointActForm/routes';

const ViolationActDetailsInfo = React.lazy(
  () => import('@/pages/ViolationActDetails/views/Information'),
);

const ViolationActDetailsDevices = React.lazy(
  () => import('@/pages/ViolationActDetails/views/Devices'),
);

export const violationActDetailsRoutes: RouteObject[] = [
  {
    path: ActFormView.Information,
    element: <ViolationActDetailsInfo />,
    index: true,
  },
  {
    path: ActFormView.Devices,
    element: <ViolationActDetailsDevices />,
  },
];
